import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/auth/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", password: "" });
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);
    const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setError("");
        try {
            await register(form.name, form.email, form.password);
            navigate("/player/dashboard");
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally { setBusy(false); }
    };

    return (
        <AuthShell title="Enlist" subtitle="Create your Outpost Network account.">
            <form onSubmit={submit} className="space-y-4">
                {error && <div data-testid="register-error" className="rounded-md border border-danger/40 bg-danger/10 px-3 py-2 text-sm text-danger">{error}</div>}
                <div>
                    <label className="label-mono text-muted-foreground">Callsign / Username</label>
                    <Input data-testid="register-name" required value={form.name} onChange={upd("name")}
                        className="mt-1 bg-background border-border" placeholder="survivor_01" />
                </div>
                <div>
                    <label className="label-mono text-muted-foreground">Email</label>
                    <Input data-testid="register-email" type="email" required value={form.email} onChange={upd("email")}
                        className="mt-1 bg-background border-border" placeholder="you@outpost.gg" />
                </div>
                <div>
                    <label className="label-mono text-muted-foreground">Password</label>
                    <Input data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={upd("password")}
                        className="mt-1 bg-background border-border" placeholder="••••••••" />
                </div>
                <Button data-testid="register-submit" type="submit" disabled={busy}
                    className="w-full font-heading uppercase tracking-wide bg-hazard text-black hover:bg-hazard/90">
                    {busy ? <Loader2 className="animate-spin" size={16} /> : "Enlist Now"}
                </Button>
                <div className="text-sm text-center text-muted-foreground">
                    Already enlisted? <Link to="/login" className="text-hazard hover:underline">Sign in</Link>
                </div>
            </form>
        </AuthShell>
    );
}
